import { ModalData } from './modal-data';

export interface ModalReloadData {
  identifier: string;
  data: ModalData;
  isClosable: boolean;
}
